import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import { Plugin as ClusterFunctionalUsagePlugin } from '../../../../clusters/plugins/functional-usage/plugin'
import type { Plugin } from '../plugin'

/**
 * Re-fetches functional usage when the cluster's functional usage is updated,
 * since the record inherits its functional usage from the assigned cluster.
 */
export const loadForCurrentEntityOnClusterFunctionalUsageChange =
  store.effects.create((feature: Plugin['feature']) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceCluster, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(clustersEc => {
        const clusterFunctionalUsagePlugin = clustersEc.plugins
          .lookup(ClusterFunctionalUsagePlugin)
          .get()

        return clusterFunctionalUsagePlugin.feature.actions.applyUpdates.success
          .observe()
          .pipe(
            rxjs.map(() =>
              feature.actions.loadForCurrentEntity.request
                .from(
                  '(effect) load for current entity on cluster functional usage change',
                )
                .create(),
            ),
          )
      }),
    ),
  )
